import { useFetchNextPageQuery } from 'hooks'
import { CmsWidgetByIdDocument as CMS_WIDGET_BY_ID_QUERY } from 'types/graphql-generated'

export const useFetchMoreByWidgetId = (options) =>
  useFetchNextPageQuery(CMS_WIDGET_BY_ID_QUERY, {
    fetchPolicy: 'cache-first', // everything should be in cache, so we can use this policy
    ...options,
  })
